import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-topic-details',
  templateUrl: './topic-details.component.html',
  styleUrls: ['./topic-details.component.scss']
})
export class TopicDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
